module.exports = __webpack_public_path__ + "img/ИФ-1(А)-036-m.4324cd45.png";